import { FaTiktok, FaYoutube, FaArrowRight, FaLinkedin, FaTwitter } from "react-icons/fa";
import React, { useRef } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";

const Footer = () => {
  const container = useRef();

  useGSAP(() => {
    const columns = gsap.utils.toArray(".footer-col");
    
    columns.forEach((col, i) => {
      const direction = i % 2 === 0 ? 1 : -1;
      gsap.fromTo(col, 
        { y: -150 * direction },
        {
          y: 150 * direction,
          ease: "none",
          scrollTrigger: {
            trigger: container.current,
            start: "top bottom",
            end: "bottom top",
            scrub: 0.5,
          }
        }
      );
    });
  }, { scope: container });

  return (
    <div ref={container} className="lg:px-10 px-5 bg-slate-950/50">
      <div className="lg:py-32 py-16 flex relative lg:gap-16 gap-5 w-full justify-center items-center lg:h-[40vh] h-52 overflow-hidden border-t border-white/5">
        <div className="footer-col flex flex-col lg:gap-6 gap-4">
          <img src="/7-1.png" alt="pic-1" className="lg:w-40 lg:h-40 w-16 h-16 rounded-2xl shadow-2xl object-cover" />
          <img src="/7-2.png" alt="pic-2" className="lg:w-40 lg:h-40 w-16 h-16 rounded-2xl shadow-2xl object-cover" />
          <img src="/7-3.png" alt="pic-3" className="lg:w-40 lg:h-40 w-16 h-16 rounded-2xl shadow-2xl object-cover" />
        </div>
        <div className="footer-col flex flex-col lg:gap-6 gap-4">
          <img src="/6-1.png" alt="pic-1" className="lg:w-40 lg:h-40 w-16 h-16 rounded-2xl shadow-2xl object-cover" />
          <img src="/6-2.png" alt="pic-2" className="lg:w-40 lg:h-40 w-16 h-16 rounded-2xl shadow-2xl object-cover" />
          <img src="/6-3.png" alt="pic-3" className="lg:w-40 lg:h-40 w-16 h-16 rounded-2xl shadow-2xl object-cover" />
        </div>
        <div className="footer-col flex flex-col lg:gap-6 gap-4">
          <img src="/5-1.png" alt="pic-1" className="lg:w-40 lg:h-40 w-16 h-16 rounded-2xl shadow-2xl object-cover" />
          <img src="/5-2.png" alt="pic-2" className="lg:w-40 lg:h-40 w-16 h-16 rounded-2xl shadow-2xl object-cover" />
          <img src="/5-3.png" alt="pic-3" className="lg:w-40 lg:h-40 w-16 h-16 rounded-2xl shadow-2xl object-cover" />
        </div>
        <div className="footer-col flex flex-col lg:gap-6 gap-4">
          <img src="/4-1.png" alt="pic-1" className="lg:w-40 lg:h-40 w-16 h-16 rounded-2xl shadow-2xl object-cover" />
          <img src="/4-2.png" alt="pic-2" className="lg:w-40 lg:h-40 w-16 h-16 rounded-2xl shadow-2xl object-cover" />
          <img src="/4-3.png" alt="pic-3" className="lg:w-40 lg:h-40 w-16 h-16 rounded-2xl shadow-2xl object-cover" />
        </div>
        <div className="footer-col flex flex-col lg:gap-6 gap-4">
          <img src="/3-1.png" alt="pic-1" className="lg:w-40 lg:h-40 w-16 h-16 rounded-2xl shadow-2xl object-cover" />
          <img src="/3-2.png" alt="pic-2" className="lg:w-40 lg:h-40 w-16 h-16 rounded-2xl shadow-2xl object-cover" />
          <img src="/3-3.png" alt="pic-3" className="lg:w-40 lg:h-40 w-16 h-16 rounded-2xl shadow-2xl object-cover" />
        </div>
        <div className="footer-col flex flex-col lg:gap-6 gap-4">
          <img src="/2-1.png" alt="pic-1" className="lg:w-40 lg:h-40 w-16 h-16 rounded-2xl shadow-2xl object-cover" />
          <img src="/2-2.png" alt="pic-2" className="lg:w-40 lg:h-40 w-16 h-16 rounded-2xl shadow-2xl object-cover" />
          <img src="/2-3.png" alt="pic-3" className="lg:w-40 lg:h-40 w-16 h-16 rounded-2xl shadow-2xl object-cover" />
        </div>
        <div className="footer-col flex flex-col lg:gap-6 gap-4">
          <img src="/nutral-pic.png" alt="pic-1" className="lg:w-40 lg:h-40 w-16 h-16 rounded-2xl shadow-2xl object-cover" />
          <img src="/nutral-pic-2.png" alt="pic-2" className="lg:w-40 lg:h-40 w-16 h-16 rounded-2xl shadow-2xl object-cover" />
          <img src="/nutral-pic-3.png" alt="pic-3" className="lg:w-40 lg:h-40 w-16 h-16 rounded-2xl shadow-2xl object-cover" />
        </div>
        
        <div className="w-[85%] max-w-6xl flex justify-between cursor-pointer items-center rounded-3xl absolute bg-gradient-to-r from-indigo-600 to-pink-600 lg:h-28 h-14 bottom-6 px-10 shadow-[0_20px_50px_rgba(79,70,229,0.3)] hover:scale-[1.02] transition-transform z-10 group">
          <h1 className="lg:text-6xl text-2xl font-black italic uppercase tracking-tighter">Get Started</h1>
          <FaArrowRight className="lg:text-5xl text-2xl group-hover:translate-x-3 transition-transform" />
        </div>
      </div>
      <div className="lg:flex justify-between items-center py-20 gap-5">
        <div className=" w-[350px] lg:text-xl text-sm">
          Dash dash terraUSD neo uniswap kadena helium avalanche polymath
          bancor.
        </div>
        <div className=" text-right mt-10 lg:mt-0">
          <div>Looking for help?</div>
          <div className=" mt-2 ">
            <input
              type="text"
              className=" border-2 bg-transparent rounded-md h-10 lg:w-44 w-[70%] p-2"
              placeholder="Enter your email"
            />{" "}
            <button className="bg-gradient-to-r px-4 py-2 h-10 ml-1 rounded-md w-[28%] from-[#8158b8] to-[#c85ec6]">
              Submit
            </button>
          </div>
        </div>
      </div>
      <hr />
      <div className=" flex justify-between items-center py-5">
        <div className=" text-xl tracking-widest">AI. GEN</div>
        <div className=" text-white flex gap-2">
          <FaTwitter />
          <FaLinkedin />
          <FaTiktok />
          <FaYoutube />
        </div>
      </div>
    </div>
  );
};

export default Footer;
